export default "__VITE_ASSET__GqAy$8t0__"